export enum SchemasType
{
    EXTRACTOR = 1,
    REPORT = 2,
    CUSTOM_CONNECTION = 3,
}